/**
 * Whether the redesigned Data Fields (CIN-6756), and anything built on it, is on for this person:
 * the `data-fields-redesign` LaunchDarkly flag, or a superuser's ?redesign=on|off override, which
 * the /data-fields route remembers in this browser so Cinch staff can QA and run the product
 * review before the flag is targeted. Customers only ever follow the flag.
 *
 * WHY one helper: every surface of the redesign must switch together.
 * Kept free of imports so scripts/data-fields-logic.test.js can load it under plain Node.
 * TODO(CIN-6756): remove the override along with the legacy page.
 */
export const REDESIGN_FLAG = 'data-fields-redesign';
export const REDESIGN_OVERRIDE_KEY = 'cinch.dataFieldsRedesign';

/** The remembered override ('on' / 'off'), or null. Storage can be blocked (private mode). */
export function readRedesignOverride() {
  try {
    return localStorage.getItem(REDESIGN_OVERRIDE_KEY);
  } catch (error) {
    return null;
  }
}
export function isDataFieldsRedesignOn({
  flags,
  isSuperuser,
  override
}) {
  return isSuperuser && override ? override === 'on' : !!flags?.[REDESIGN_FLAG];
}